import React, { useState, useContext, useEffect, useRef } from 'react';
import axiosConfig from '../../configs/axios.config';
import axios from 'axios'
import { Input, Button, Space, Form, Row, Col, InputNumber } from 'antd';

const { Search, TextArea } = Input;
const InventoryBarcode = () => {
    const inputRef = useRef(null);

    const [form] = Form.useForm();
    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 7 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
        },
    };
    const [noti, setNoti] = useState('')
    const [BarCodeSearch, setBarCodeSearch] = useState('')

    const [found, setfound] = useState({
        ItemCode: '',
        BarCode: '',
        Qty: 0,
        NewItemCode: '',
        ChungNhan: '',
        DinhLuong: '',
        LoaiGiay: '',
        NhanHang: '',
        ChieuRong: 0,
        QCChieuDai: 0,
        Note: ''
    })
    const onSearch = async (value) => {
        // const FSearch = loadData.find(element => element.BarCode === value)
        const FSearch = await axios.create(axiosConfig).post('api/inventory/GetInventory', '{"BarCode":"' + value + '"}')

        if (FSearch.data.result.length > 0) {
            setNoti('')
            setfound(FSearch.data.result[0]);
            console.log('show', FSearch)
        }
        else {
            setfound({
                ItemCode: '',
                BarCode: value,
                Qty: 0,
                NewItemCode: '',
                ChungNhan: '',
                DinhLuong: '',
                LoaiGiay: '',
                NhanHang: '',
                ChieuRong: 0,
                QCChieuDai: 0,
                Note: ''
            })
            console.log('not show')
            setNoti('Không tim thấy thông tin')
        }
        const response = await axios.create(axiosConfig).post('api/inventory/getCheckBarCode', '{"BarCode":"' + value + '"}')
        if (response.data.success && response.data.result.length > 0) {
            setNoti('BarCode trùng: ' + response.data.result[0].NewItemCode + '-' + response.data.result[0].Qty)

        }

    };
    const onFinish = async (values) => {
        inputRef.current.focus({
            cursor: 'all',
        });

        if (found.BarCode === '')
            setNoti('Vui lòng nhập barcode')
        else if (found.Qty < 1)
            setNoti('Vui lòng nhập số lượng lớn hơn 0')
        else {
            setNoti('')
            console.log('Received values of form: ', found);
            const response = await axios.create(axiosConfig).post('api/inventory/PostInsertInventory', found)
            if (response.data.success) {
                setfound({
                    ItemCode: '',
                    BarCode: '',
                    Qty: 0,
                    NewItemCode: '',
                    ChungNhan: '',
                    DinhLuong: '',
                    LoaiGiay: '',
                    NhanHang: '',
                    ChieuRong: 0,
                    QCChieuDai: 0,
                    Note: ''
                })
                setBarCodeSearch('')
            }

        }



    };
    const onFormChange = event => {
        if (found)
            setfound({ ...found, [event.target.name]: event.target.value })
    }
    const onNumChange = name => value => {
        if (found)
            setfound({ ...found, [name]: value })
    }
    const onSearchChange = (e) => {
        setBarCodeSearch(e.target.value)
    }
    const sharedProps = {
        ref: inputRef,
    };
    return (
        <>
            <div className='custom-searchtext'>
                <Search
                    placeholder="Tìm kiếm..."
                    allowClear
                    enterButton="Tìm kiếm"
                    size="large"
                    onSearch={onSearch}
                    onChange={onSearchChange}
                    value={BarCodeSearch ? BarCodeSearch : ''}
                    {...sharedProps}
                />
            </div>
            
            {
                noti ? 
                <h3 style={{ color: 'red', marginBottom: '16px' }}>{noti}</h3> : ''
            }
            <Form {...formItemLayout} form={form} name="advanced_search" layout="horizontal" className="ant-advanced-search-form" size={'small'} onFinish={onFinish} >

                <Row gutter={22}>
                    <Col span={7} key={0}>
                        <Form.Item name={`ItemCode`} label={`Mã hàng cũ`} disabled >
                            {found ? found.ItemCode : ''}
                        </Form.Item>
                    </Col>
                    <Col span={7} key={1}>
                        <Form.Item name={`NewItemCode`} label={`Mã hàng mới`} disabled >
                            {found ? found.NewItemCode : ''}
                        </Form.Item>
                    </Col>
                    <Col span={7} key={2}>
                        <Form.Item name={`ChungNhan`} label={`Chứng nhận`} disabled >
                            {found ? found.ChungNhan : ''}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={22}>
                    <Col span={7} key={3}>
                        <Form.Item name={`LoaiGiay`} label={`Loại giấy`} disabled >
                            {found ? found.LoaiGiay : ''}

                        </Form.Item>
                    </Col>
                    <Col span={7} key={4}>
                        <Form.Item name={`NhanHang`} label={`Nhãn hàng`} disabled >
                            {found ? found.NhanHang : ''}
                        </Form.Item>
                    </Col>
                    <Col span={7} key={5}>
                        <Form.Item name={`DinhLuong`} label={`Định lượng`} disabled >
                            {found ? found.DinhLuong : ''}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={22}>
                    <Col span={7} key={3}>
                        <Form.Item name={`ChieuRong`} label={`Chiều dộng`} disabled >
                            {found ? found.ChieuRong : ''}
                        </Form.Item>
                    </Col>
                    <Col span={7} key={4}>
                        <Form.Item name={`QCChieuDai`} label={`Chiều dài`} disabled >
                            {found ? found.QCChieuDai : ''}
                        </Form.Item>
                    </Col>
                    <Col span={7} key={5}>
                        <Form.Item  label={`Khối lượng`} >
                            <InputNumber value={found ? found.Qty : 0} onChange={onNumChange("Qty")} />
                            <br />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={22}>
                    <Col span={21} key={5} >
                        <Form.Item label={`Ghi chú`} style={{display: 'flex', justifyContent: 'space-between'}}>
                            <Input name={`Note`} value={found ? found.Note : ''} showCount maxLength={100} onChange={onFormChange} />
                            <br />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={21} style={{ display: 'flex', justifyContent: 'right', }}>
                        <Button type="primary" htmlType="submit" >
                            Xác nhận
                        </Button>
                    </Col>
                </Row>


            </Form>
        </>
    );
};



export default InventoryBarcode;